import React from 'react';
import {
  isAtlassianCloud,
  isCommercialOrAcademicOrFreeType,
  isCommercialOrAcademicType,
  isEvaluationType,
  isFreeType,
  isFutureEndDate,
  isNextMonthFutureDate,
  isNextMonthPastDate,
  isNoLicenseKeyValueDisplayedForKeys,
  isNotMoreThat5DaysOverdue,
  isPastEndDate,
  notPartOfForRenewKeys,
} from 'util/mac/helpers';
import { FreeExtensionAppliedMessage } from './FreeExtensionAppliedMessage';
import { StyledButtonsWrapper, StyledFlex } from '../StyledComponents';
import { ActionsMessage } from './ActionsMessage';
import { ClaimYourSiteLink } from './ClaimYourSiteLink';
import { ArchiveUnarchiveButtonLink } from './ArchiveUnarchiveButtonLink';
import { NeedSiteAdministratorMessage } from './NeedSiteAdministratorMessage';
import { ProductAdminLink } from './ProductAdminLink';
import { ExpiredMessage } from './ExpiredMessage';
import { BuyLink } from './BuyLink';
import { RenewLink } from './RenewLink';
import Progress from 'redux-progress';

type HostedNonAtlassianOrganizationAccountProps = {
  isSiteOnConcession: boolean;
  isArchiveButtonVisible: boolean;
  isArchived: boolean;
  isAccount: boolean;
  productKey: string;
  isRenewalActionNone: boolean;
  isRenewableAccount: Progress<boolean>;
  accountDetails: any;
};

export const HostedNonAtlassianOrganizationAccount = ({
  isSiteOnConcession,
  isArchiveButtonVisible,
  isArchived,
  isAccount,
  productKey,
  isRenewalActionNone,
  isRenewableAccount,
  accountDetails,
}: HostedNonAtlassianOrganizationAccountProps) => {
  const {
    isUnclaimedCloudSite,
    id: accountId,
    renewalAction,
    externalUuid,
    name: accountName,
    domain,
    latestPeriod: { endDate },
    merchandise: {
      details: { licenseType },
      productEdition: { monthsValid },
    },
  } = accountDetails;
  const hasExternalUuid = !!externalUuid;

  if (isUnclaimedCloudSite && isFutureEndDate(endDate) && isSiteOnConcession) {
    return (
      <>
        <FreeExtensionAppliedMessage />
        <StyledFlex>
          <ActionsMessage />
          <StyledButtonsWrapper>
            <ClaimYourSiteLink externalUuid={externalUuid} />
            <ArchiveUnarchiveButtonLink
              isArchiveButtonVisible={isArchiveButtonVisible}
              isArchived={isArchived}
              accountId={accountId}
              isAccount={isAccount}
            />
          </StyledButtonsWrapper>
        </StyledFlex>
      </>
    );
  }
  if (isEvaluationType(licenseType) && renewalAction === 'AUTO_RENEW') {
    return (
      <>
        {isAtlassianCloud(productKey) && <NeedSiteAdministratorMessage />}
        {isSiteOnConcession && <FreeExtensionAppliedMessage />}
        <StyledFlex>
          <ActionsMessage />
          <StyledButtonsWrapper>
            {isNextMonthFutureDate(endDate) && (
              <ProductAdminLink
                domain={domain}
                accountName={accountName}
                productKey={productKey}
                hasExternalUuid={hasExternalUuid}
              />
            )}
            {isPastEndDate(endDate) && <ExpiredMessage />}
            <BuyLink productKey={productKey} />
            <ArchiveUnarchiveButtonLink
              isArchiveButtonVisible={isArchiveButtonVisible}
              isArchived={isArchived}
              accountId={accountId}
              isAccount={isAccount}
            />
          </StyledButtonsWrapper>
        </StyledFlex>
      </>
    );
  }
  if (isFreeType(licenseType) || isNotMoreThat5DaysOverdue(endDate)) {
    return (
      <>
        {isAtlassianCloud(productKey) &&
          isCommercialOrAcademicOrFreeType(licenseType) &&
          isNextMonthFutureDate(endDate) &&
          !isRenewalActionNone &&
          hasExternalUuid && <NeedSiteAdministratorMessage />}
        {isSiteOnConcession && <FreeExtensionAppliedMessage />}
        <StyledFlex>
          <ActionsMessage />
          <StyledButtonsWrapper>
            {isNextMonthFutureDate(endDate) &&
              isCommercialOrAcademicOrFreeType(licenseType) &&
              !isRenewalActionNone && (
                <ProductAdminLink
                  domain={domain}
                  accountName={accountName}
                  productKey={productKey}
                  hasExternalUuid={hasExternalUuid}
                />
              )}
            {isCommercialOrAcademicType(licenseType) &&
              (isNextMonthPastDate(endDate) || isRenewalActionNone) && <ExpiredMessage />}
            {!notPartOfForRenewKeys.includes(productKey) &&
              (isNoLicenseKeyValueDisplayedForKeys(productKey) || isRenewableAccount) &&
              monthsValid > 1 && <RenewLink accountId={accountId} />}
            <ArchiveUnarchiveButtonLink
              isArchiveButtonVisible={isArchiveButtonVisible}
              isArchived={isArchived}
              accountId={accountId}
              isAccount={isAccount}
            />
          </StyledButtonsWrapper>
        </StyledFlex>
      </>
    );
  }
  return (
    <>
      {isSiteOnConcession && <FreeExtensionAppliedMessage />}
      <StyledFlex>
        <ActionsMessage />
        <StyledButtonsWrapper>
          <ArchiveUnarchiveButtonLink
            isArchiveButtonVisible={isArchiveButtonVisible}
            isArchived={isArchived}
            accountId={accountId}
            isAccount={isAccount}
          />
        </StyledButtonsWrapper>
      </StyledFlex>
    </>
  );
};
